import { useAdminCreditManagementData } from './useAdminCreditManagementData';
import { CreditManagement } from '../index';

export const AdminCreditManagement: React.FC = () => {
  const { credits, isLoading, isError, isFetching, errorMessage } =
    useAdminCreditManagementData();

  return (
    <CreditManagement
      credits={credits}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
    />
  );
};
